import React from 'react'
import { Link } from "react-router-dom";
import { Button } from 'antd';

import '../assets/css/noFound.scss'

const noFoundPic = require("../assets/images/404.png")

const NoFound: React.FC = function () {
  return <>
    <div className="noFoundWrap">
      <div className="noFoundPic">
        <img src={noFoundPic} alt="" />
      </div>
      <Button type="primary" className="goBack">
        <Link to="/login">返回</Link>
      </Button>
    </div>
  </>
}

export default NoFound